<template>

  <v-card>
    <v-data-table
      v-model="selected"
      single-select
      show-select
      :headers="headers"
      :items="products"
      class="flex-grow-1"
      item-key="productId"
      :footer-props="{showFirstLastPage: true}"
      disable-sort
      @item-selected="selectProduct"
    >
      <template v-slot:item.category="{ value }">
        {{value.categoryName}}
      </template>

      <template v-slot:item.createdAt="{ value }">
        <div>{{ value | moment('YYYY-MM-DD HH:mm:ss') }}</div>
      </template>

    </v-data-table>

  </v-card>

</template>

<script>
import PresentApi from "@/api/PresentApi"

export default {
  components: {
  },
  props: {
    presentId: {
      type: String
    }
  },
  data() {
    return {
      selected:[],
      isLoading: false,
      searchQuery: '',
      waitingSearch: false,
      selectedUsers: [],
      headers: [
        { text: '분류', align: 'left', value: 'product.category.categoryName' },
        { text: '제품명', align: 'left', value: 'product.productName' },
        { text: '주문수량', value: 'orderCount' },
        { text: '수량', value: 'quantity' },
        { text: '생성일', value: 'createdAt' },
        { text: '', sortable: false, align: 'right', value: 'action' }
      ],
      param:{},
      totalItems: 0,
      products: []
    }
  },
  mounted() {
    this.selected = [{productId:this.selectedProductId}];
  },
  watch: {
    selectedProductId: {
      handler(nv) {
        this.selected = [{productId:nv}];
      },
      deep: true
    },
    selectedProduct: {
      handler(nv) {
        this.selected = nv;
      },
      deep: true
    },
  },
  methods: {
    selectProduct({item, value}) {
      if(item.quantity && (item.quantity - item.orderCount) < 1) {
        alert('수량이 부족합니다.')
        return
      }
      if(value) {
        this.$emit('product-selected', item);
      }
    },
    getProducts() {
      PresentApi.productList(this.presentId).then(data => {
        console.log(data);
        this.products = data;
      })
    }
  },
  created() {
    this.getProducts();
  }
}
</script>
